import React, { useEffect } from "react";
import classes from "./Home.module.css";
import WelcomeMessage from "./Welcome/WelcomeMessage";
import LeftPanel from "../../layout/leftPanel/LeftPanel";
import BoxesContainer from "../../../SMARTCITY/components/boxesContainer/BoxesContainer";
import Charts from "../charts/Charts";
import Tableau from "../../../SMARTCITY/components/tableau/Tableau";
import styled from "styled-components";

const Home = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100% - 100px)",
        display: "flex",
        flexDirection: "row",
        paddingTop: "70px",

        // flexWrap: "wrap",
        // gap: "30px",
        // alignItems: "flex-start",
        // justifyContent: "center",
      }}
    >
      {/*<LeftPanel*/}
      {/*  open={false}*/}
      {/*  buttonExpandName={"Γραφήματα"}*/}
      {/*  className={classes.leftPanel_Charts}*/}
      {/*>*/}
      {/*  <Charts />*/}
      {/*</LeftPanel>*/}
      {/*<LeftPanel*/}
      {/*  open={false}*/}
      {/*  buttonExpandName={"Χρονοσειρές"}*/}
      {/*  className={classes.horizontal_side_panel_tableau}*/}
      {/*>*/}
      {/*  <Tableau />*/}
      {/*</LeftPanel>*/}
      <WelcomeWrapper>
        <WelcomeMessage />
      </WelcomeWrapper>
      <BoxesContainer />
    </div>
  );
};

export default Home;

const WelcomeWrapper = styled.div`
  display: flex;

  @media only screen and (max-width: 908px) {
    display: none;
  }
`;
